import { Box } from '@material-ui/core';
import { motion } from 'framer-motion';

const SkeletonLoader = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.2 }}>
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '5px'
      }}>
      <motion.div
        animate={{
          backgroundColor: ['#E0E0E0', '#F5F5F5', '#E0E0E0']
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }}
        style={{
          width: '60px',
          height: '24px',
          borderRadius: '4px'
        }}
      />
      <motion.div
        animate={{
          backgroundColor: ['#E0E0E0', '#F5F5F5', '#E0E0E0']
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.1
        }}
        style={{
          width: '50px',
          height: '24px',
          borderRadius: '4px'
        }}
      />
    </Box>
  </motion.div>
);

export default SkeletonLoader;
